// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__sP2KK","fullWidth":"Container_fullWidth__2QBmK"};